import React, { useState, useEffect, useRef } from "react";
import styles from "./Control.module.css";
import { FaBars } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import logo from "../../assets/logo.png";

function Control() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  const handleToggle = () => {
    setIsMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    if (!isMenuOpen) return;

    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  useEffect(() => {
    const menu = document.querySelector(`.${styles.slideshowItems}`);
    if (!menu) return;

    const items = menu.querySelectorAll("li");

    if (isMenuOpen) {
      items.forEach((item, index) => {
        setTimeout(() => {
          item.classList.add(styles.visible);
        }, index * 100);
      });
    } else {
      items.forEach((item) => {
        item.classList.remove(styles.visible);
      });
    }
  }, [isMenuOpen]);

  const handleMenuItemClick = (event) => {
    setIsMenuOpen(false);
  };

  return (
    <div>
      {isMenuOpen && (
        <div className={styles.mobileMenu}>
          <div className={styles.slideshowItems} ref={menuRef}>
            <ul>
              <li>
                <a href="#practice-areas" onClick={handleMenuItemClick}>
                  PRACTICE AREAS
                </a>
              </li>
              <li>
                <a href="#resources" onClick={handleMenuItemClick}>
                  RESOURCES
                </a>
              </li>
              <li>
                <a href="#contact-us" onClick={handleMenuItemClick}>
                  CONTACT US
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}

      <div className={styles.head}>
        <div className={styles.leftSection}>
          <img src={logo} alt="Logo" className={styles.logo} />
          <h1 className={styles.brand}>
            <a href="#home"> LIBERTY & JUSTICE ADVOCATES</a>
          </h1>
        </div>

        <div className={styles.rightSection}>
          <div className={styles.desktopMenu}>
            <ul>
              <li>
                <a href="#practice-areas" onClick={handleMenuItemClick}>
                  PRACTICE AREAS
                </a>
              </li>
              <li>
                <a href="#resources" onClick={handleMenuItemClick}>
                  RESOURCES
                </a>
              </li>
              <li>
                <a href="#contact-us" onClick={handleMenuItemClick}>
                  CONTACT US
                </a>
              </li>
            </ul>
          </div>

          <div className={styles.toggleIcon}>
            {isMenuOpen ? (
              <GrClose size={28} onClick={handleToggle} />
            ) : (
              <FaBars size={28} onClick={handleToggle} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Control;
